import { fork, all } from 'redux-saga/effects'
import { processSaga, watchSaga } from '../workflow'
import at from '../../actionTypes' // eslint-disable-line import/no-named-as-default, temporary until we only export the one thing
import { getParamsForNotificationsByUid, getParamsForMoreNotificationsByUid, getParamsForNotificationsSeenSet, notificationsSeen } from './sagas'
import getNotificationsByUid from '../../../dataservices/getNotificationsByUid'
import actionWorkflows from '../../actionWorkflows'

const notificationsFetchWorkflow = processSaga.bind(null, actionWorkflows.notificationsFetch, getNotificationsByUid)
const notificationsMoreFetchWorkflow = processSaga.bind(null, actionWorkflows.notificationsMoreFetch, getNotificationsByUid)
const notificationsSeenWorkflow = processSaga.bind(null, actionWorkflows.notificationsSeenSet, notificationsSeen)

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, at.notificationsFetch, notificationsFetchWorkflow, { latest: true, selectParams: getParamsForNotificationsByUid })),
		fork(watchSaga.bind(null, at.notificationsMoreFetch, notificationsMoreFetchWorkflow, { latest: true, selectParams: getParamsForMoreNotificationsByUid })),
		fork(watchSaga.bind(null, at.notificationsSeenSet, notificationsSeenWorkflow, { latest: true, selectParams: getParamsForNotificationsSeenSet }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/notifications/index.js